import $ from 'jquery';
import { openPopup } from "./layouts/popup";
import { loadElementLazyImage } from './helpers/lazy-load'
import { updateUrlParameter, getUrlParameter } from './helpers/url-params'



$('.js-test').each(function(){
  let test = $(this)
  let completed = test.hasClass('js-completed')
  let curQuestion = test.data('current-question')
  let curSubQuestion = null
  let totQuestions = test.data('total-count') - 1
  let nextQuestion = test.find('.js-next-question')
  let testId = test.data('test-id')
  let catId = test.data('cat-id')
  let companyId = test.data('company-id')


  function goToQuestion(num){
    let subQuestion = Number.isInteger(num) ? false : true;
    let question = test.find('.js-question[data-question="'+num+'"]')
    
    if (subQuestion){
      curSubQuestion = num.split('_')[1]
      //$('.js-cur-question').text((parseInt(curQuestion) + 1) + ', apakšjautājums ' + (parseInt(curSubQuestion) + 1) )
      $('.js-cur-question').text('Jautājuma ' + (parseInt(curQuestion) + 1) + ' apakšjautājums')

    } else {
      curSubQuestion = null
      curQuestion = num
      $('.js-cur-question').text('Jautājums '+ (num + 1))
    }


    test.find('.js-question').hide()


    // load lazy elements
    loadElementLazyImage(question.find('.lazy, .lazy-manual'))

    $('.status-el').removeClass('current')
    $('.js-status-' + num).addClass('current')

    // show question
    question.fadeIn()

  }


  // initialize test
  if (curQuestion !== ''){
    startTest(curQuestion)
    // let $firstLoadedQuestion = test.find('.js-question[data-question="'+curQuestion+'"]')
    // $firstLoadedQuestion.fadeIn()
    // loadElementLazyImage($firstLoadedQuestion.find('.lazy-manual, .lazy'))
  }


  // start test
  $('.js-start-test').click( ()=> {
    startTest(0)
  })


  function startTest(question){
    $('.js-test-intro').hide()
    $('.js-go-back').hide()
    $('.js-test-questions').fadeIn()
    $('.js-pagination').fadeIn()
    goToQuestion(question)
  }


  // next question
  nextQuestion.click(()=> {

    // get current question el
    let curQuestionId = curQuestion
    if (curSubQuestion) curQuestionId = curQuestion + '_' + curSubQuestion
    let questionEl = test.find('.js-question[data-question="'+curQuestionId+'"]')


    let last_slide = test.find('.js-last-end-slide')

    // check if next need be sub question
    let has_sub_question = false;
    questionEl.find('.js-answer.js-checked').each(function(){
      if ($(this).attr('data-has-sub-question')){
        has_sub_question = $(this).attr('data-has-sub-question')
      }
    })
    //if (!questionEl.hasClass('js-correct')) has_sub_question = false


    $('.js-at-least-one-message-textarea').hide()
    $('.js-at-least-one-message').hide()


    if (has_sub_question){
      goToQuestion(curQuestion + '_' + has_sub_question)

    } else {
      if (curQuestion < totQuestions){
        curQuestion++
        goToQuestion(curQuestion)

      } else {
        location.reload()
      }
    }
    
    // remove next arrow if last question
    if (curQuestion == totQuestions && completed) test.find('.js-next-question').addClass('js-button-hidden')
  })


  test.find('.js-answer').click(function(){
    let question = $(this).closest('.js-question')
    let answers = question.find('.js-answer')
    let oneAnswer = question.data('right')

    if (oneAnswer === 1){
      question.find('.js-answer').removeClass('js-checked')
    }

    $(this).toggleClass('js-checked')

    let answeredCount = question.find('.js-checked').length
    question.removeClass('js-can-submit')

    if (answeredCount > 0) {
      question.addClass('js-can-submit')
      $('.js-at-least-one-message').fadeOut()
    } else {
      $('.js-at-least-one-message').fadeIn()
    }

  })

  test.find('.js-free-answer').on('input', function() {
    let question = $(this).closest('.js-question')

    if ($(this).val() !== ''){
      question.addClass('js-can-submit')
    } else {
      question.removeClass('js-can-submit')
    }
  })


  test.find('.js-submit-answer').click(function(){
    let answers = []
    let question = $(this).closest('.js-question')
    let $answers = question.find('.js-answer')
    let isLastQuestion = curQuestion >= totQuestions ? 1 : 0
    let answerButton = $(this)
    let questionNum = question.attr('data-question')
    let canSubmit = question.hasClass('js-can-submit')
    let freeAnswer = question.find('.js-free-answer')
    let answerText = '';

    if (!canSubmit) {
      if (freeAnswer.length){
        $('.js-at-least-one-message-textarea').fadeIn()
      } else {
        $('.js-at-least-one-message').fadeIn()
      }
      return;
    }

    if (freeAnswer.length){
      answers = [];
      answerText = freeAnswer.val()

    } else {
      question.find('.js-checked').each((i, el) => answers.push(parseInt($(el).data('key'))) )
    }
    
    
    test.find('.js-update-error-message').hide()
    $.ajax({
      type: "POST",
      url: localize_script.admin_ajax,
      data: {
        action: 'submitAnswer',
        testId: testId,
        catId: catId,
        companyId: companyId,
        question: questionNum,
        answers: JSON.stringify(answers),
        answerText: answerText,
        isLastQuestion: isLastQuestion,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      success: function (results) {
        if (!results.testEnded) {
          //if (results.updated) {

            setCorrectWrongAnswersAndClouds(results.correct, answers, results.score, question)
            
            question.find('.js-submit-answer').hide()
            question.find('.js-next-question').fadeIn()
            question.addClass('answered')

          // } else {
          //   test.find('.js-update-error-message').fadeIn()
          // }

        } else {
          answerButton.addClass('disabled');
          test.find('.js-final-time-ended-message').fadeIn()
          answerButton.closest('.js-question').removeClass('js-can-submit')
        }
      }
    });

  })


  function setCorrectWrongAnswersAndClouds(resultsCorrect, answers, score, question){
    let correctArr = JSON.parse(resultsCorrect)
    let correctCloud = question.find('.js-answered-correct.correct')
    let wrongCloud = question.find('.js-answered-correct.wrong')
    let hasWrongNumArr = []
    let hasCorrectNumArr = []
    let realRightCount = 0

    for (const a of correctArr) {
      if (a.pareiza) realRightCount++
    }


    // free input qestion
    if (question.find('.js-free-answer').length){
      $('.js-status-' + question.data('question')).addClass('correct')
    }


    if (correctArr.length){
      // show right answers
      correctArr.forEach((el, key) => {
        let answerEl = question.find('.js-answer[data-key="'+key+'"]')
        if (el.pareiza && !answerEl.hasClass('js-checked')) answerEl.addClass('right-answer')
      })
      

      for (const a of answers) {
        let answerEl = question.find('.js-answer[data-key="'+a+'"]')

        if (correctArr[a].pareiza){
          answerEl.addClass('correct')
          hasCorrectNumArr.push(a)
        } else {
          answerEl.addClass('wrong')
          hasWrongNumArr.push(a)
        }
      }



      if (hasWrongNumArr.length || !score){
        let textC = wrongCloud.find('.js-text')
        textC.text('')

        for (const a of correctArr) {
          if (a.answer_why){
            textC.append(a.answer_why)
            break
          }
        }

        // if (realRightCount > 1){
        //   for (const a of correctArr) {
        //     if (a.pareiza) textC.append(a.answer_why);
        //   }

        // } else {
        //   if (hasWrongNumArr.length){
        //     for (const a of hasWrongNumArr) {
        //       textC.append(correctArr[a].answer_why)
        //     }
        //   }
        // }

        wrongCloud.fadeIn()
        $('.js-status-' + question.data('question')).addClass('wrong')

      } else {
        let textC = correctCloud.find('.js-text')
        textC.text('')
        question.addClass('js-correct')

        for (const a of correctArr) {
          if (a.answer_why){
            textC.append(a.answer_why)
            break
          }
        }

        // if (realRightCount > 1){
        //   for (const a of correctArr) {
        //     if (a.pareiza) textC.append(a.answer_why);
        //   }

        // } else {
        //   if (hasCorrectNumArr.length){
        //     for (const a of hasWrongNumArr) {
        //       textC.append(hasCorrectNumArr[a].answer_why)
        //     }
        //   }
        // }

        correctCloud.fadeIn()
        $('.js-status-' + question.data('question')).addClass('correct')
      }
    }

  }



})
